// This file exports an implementation of the Perseus logging interface that
// bridges to webapp's logging/error infra.

import type {ErrorKind} from "@khanacademy/perseus-core";
import type {Metadata} from "@khanacademy/wonder-stuff-core";
import Log, {
    Errors as WebappErrors,
    type ErrorKind as WebappErrorKind,
} from "@khan/logging";
import {RequestInfo} from "@khan/shared-core";

import type {ILogger, LogErrorOptions} from "../perseus.ts";

const mapErrorKindToWebapp = (kind: ErrorKind): WebappErrorKind => {
    switch (kind) {
        case "Unknown":
        case "Internal":
            return WebappErrors.Internal;
        case "InvalidInput":
            return WebappErrors.InvalidInput;
        case "NotAllowed":
            return WebappErrors.NotAllowed;
        case "Service":
            // Perseus doesn't know about Khan services, so by definition, all
            // service errors a "non-Khan"
            return WebappErrors.Service;
        case "TransientService":
            // Perseus doesn't know about Khan services, so by definition, all
            // transient service errors a "non-Khan"
            return WebappErrors.TransientService;

        default:
            // Ensures that if we add future values to the Perseus error type,
            // we'll know we need to map them here.
            const _: never = kind;
            return WebappErrors.InvalidInput;
    }
};

export class LoggingAdapter implements ILogger {
    log(message: string, extra?: Metadata | null) {
        Log.log(message, extra);
    }

    error(message: string, kind: ErrorKind, extra?: LogErrorOptions) {
        Log.error(message, mapErrorKindToWebapp(kind), {
            cause: extra?.cause,
            metadata: extra?.metadata,
            sentryData: {
                contexts: {
                    requestInfo: {
                        isUnsupportedBrowser: RequestInfo.isUnsupportedBrowser,
                    },
                    ...(extra?.loggedMetadata
                        ? {perseus: extra?.loggedMetadata}
                        : {}),
                },
            },
        });
    }
}
